module.exports = __webpack_public_path__ + "img/checkmark-circle.a86082f5.svg";